import styled from 'styled-components';

export const FiltersRow = styled.div`
  display: flex;
  flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'row')};
  align-items: ${({ $isMobile }) => ($isMobile ? 'stretch' : 'center')};
  gap: 10px;
  flex-wrap: wrap;
`;

export const SearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: ${({ $isMobile }) => ($isMobile ? '0 0 auto' : '1 1 220px')};
  ${({ $isMobile }) => ($isMobile ? 'width: 100%;' : '')}
  min-width: ${({ $isMobile }) => ($isMobile ? '0' : '180px')};
  height: 44px;
  box-sizing: border-box;
  padding: 0 12px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background: #fff;
`;

export const SearchInput = styled.input`
  flex: 1;
  min-width: 0;
  border: 0;
  outline: none;
  background: transparent;
  font-size: 14px;
`;
